import React from "react";

const columns = [
  "Name",
  "Credits / Total Value",
  "Date Requested",
  "Status",
  "Approve/Deny",
];

export default function StudentRewardsTableHeader() {
  return (
    <div className="students-rewards-history-table-header">
      {columns.map((column, index) => (
        <p className="flex flex-align-center" key={index}>
          {column}
        </p>
      ))}
    </div>
  );
}
